export default "__VITE_ASSET__BUNT1oGu__"